<template>
    <div>
        <b-input-group>
            <b-input-group-prepend v-if="special_issue">
                <div style="padding-top: .45rem;">
                    <b-badge variant="primary">
                        Special issue
                    </b-badge>
                </div>
            </b-input-group-prepend>
            <b-input-group-prepend v-if="prefix_label">
                <div style="font-size: 12px; font-weight: bold; padding-top: .65rem;" class="mr-2">
                    {{ prefix_label }}
                </div>
            </b-input-group-prepend>
            <b-form-input
                ref="title"
                type="text"
                class="title px-2 bg-transparent border-0"
                :class="{'dark': (variant == 'secondary' || variant == 'dark'), 'unit-group': unit_group && unit_group.id}"
                v-model="editable_title"
                :placeholder="placeholder ? placeholder : 'no title'"
                :disabled="disabled == true || disabled == 1"
                @blur="save"
                @keypress.enter="$event.target.blur()"
            />
            <b-input-group-append v-if="editable_title">
                <b-btn
                    :variant="copy_to_clipboard_btn_variant"
                    :class="{'active': copying_to_clipboard}"
                    content="Copy to Clipboard"
                    v-tippy="{placement: 'top'}"
                    @click="copyToClipboard"
                    :disabled="copying_to_clipboard"
                >
                    <span v-if="copying_to_clipboard">
                        <font-awesome-icon :icon="['fas', 'check']" fixed-width />
                    </span>
                    <span v-else>
                        <font-awesome-icon :icon="['fad', 'clipboard']" fixed-width />
                    </span>
                </b-btn>
            </b-input-group-append>
        </b-input-group>
    </div>
</template>

<style lang="scss" scoped>
@import '@/assets/css/_colors';

.title {
    &.unit-group {
        font-size: 1.25rem;
        line-height: 1;
        height: 1rem;
    }

    &.dark {
        color: $white;

        &::placeholder { color: darken($white, 10%); }
        &:-ms-input-placeholder { color: darken($white, 10%); }
        &::-ms-input-placeholder { color: darken($white, 10%); }
    }
}
</style>

<script>
import copy from 'copy-html-to-clipboard'

export default {
    data: () => ({
        editable_title: null,
        copying_to_clipboard: false
    }),
    props: [
        'value',
        'publication',
        'unit_group',
        'unit',
        'article',
        'variant',
        'disabled',
        'special_issue',
        'prefix_label',
        'placeholder',
    ],
    components: {},
    watch: {
        value: {
            handler (value) {
                if (value) {
                    this.editable_title = value
                } else {
                    this.editable_title = null
                }
            }
        }
    },
    computed: {
        changes () {
            let changes = false

            if (!_.isEqual(this.editable_title, this.value)) {
                changes = true
            }

            return changes
        },
        copy_to_clipboard_btn_variant () {
            let variant = this.variant

            if (this.copying_to_clipboard) {
                variant = 'success'
            }

            return variant
        }
    },
    methods: {
        save () {
            if (this.changes) {
                this.update()
            }

            if (this.$refs.title) {
                this.$refs.title.blur()
            }
        },
        update () {
            this.$emit('update', this.editable_title)
        },
        copyToClipboard () {
            copy(this.value, {
                asHtml: false
            })

            this.copying_to_clipboard = true

            setTimeout(() => {
                this.copying_to_clipboard = false
            }, 1500)
        }
    },
    mounted () {
        if (this.value) {
            this.editable_title = this.value
        }
    }
}
</script>
